export class ImprovementRequestSearch{
    Products: InfoProduct[];
    FunctionalAreas: InfoFunctionalArea[];
}

class InfoProduct{
    ProductCode: string;
    Description: string
}
class InfoFunctionalArea{
    FunctionalAreaCode: string;
    Description: string;
    EnglishDescription: string;
}

export enum TipoStatoProposta
{
    "Da Esaminare" = 41156608,
    "Accettata" = 41156609,
    "Rifiutata" = 41156610,
    "Trasformata In Miglioria" = 41156611,
    "Già Implementata" = 41156612
}